const IsUserLoggedIn = () => Number(document.documentElement.getAttribute('login')) !== 0;

export default IsUserLoggedIn;
